import './index.less';
import './i18n/index';
import './utils/skynet';

import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import App from '@/App';

import routes from './routes';
import reachRoutes from './routes/reachRoutes';

const El = document.getElementById('root') as Element;

ReactDOM.createRoot(El).render(
  <React.StrictMode>
    <BrowserRouter>
      <React.Suspense fallback="">
        <Routes>
          {/* 用户服务相关页面路由 */}
          <Route path="/app/*" element={<App />}>
            {routes.map((route) => route)}
            <Route path="*" element={<Navigate to="/" replace />}></Route>
          </Route>
          {/* 触达相关页面路由 */}
          <Route path="/:lang?/*" element={<App />}>
            {reachRoutes.map((route) => route)}
          </Route>
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  </React.StrictMode>,
);
